// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-auto[data-v-37609025]{height:auto}@media (min-width:1024px){.content-container[data-v-37609025]{flex-direction:row}.content-container .left-flex[data-v-37609025]{padding-top:.4rem;margin-right:4rem;max-width:64.8rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
